import React from 'react';
import { formatNumber } from '../../../utils/geoUtils';

const StageImportTable = ({ items = [], onDelete, onEdit, loading }) => {
    const handleDelete = (item) => {
        const confirmMsg = `Usunąć ${item.type.toUpperCase()} "${item.name}" wraz z całą relacją punktów?`;
        if (window.confirm(confirmMsg)) {
            onDelete(item.id, item.type);
        }
    };

    // Date formatting removed as columns are removed

    const getTypeBadge = (type) => {
        if (type === 'stage') {
            return <span className="badge badge-stage">Stage</span>;
        }
        return <span className="badge badge-road">Road</span>;
    };

    const getKindBadge = (kind) => {
        if (kind === 'LIAISON') {
            return <span className="badge badge-kind-liaison">LIAISON</span>;
        }
        if (kind === 'OS') {
            return <span className="badge badge-kind-os">OS</span>;
        }
        return null;
    };

    const getGpxSource = (item) => {
        const hasOwnGpx = item.type === 'road' || (item.type === 'stage' && !item.template_road_id);
        const sourceText = item.type === 'stage'
            ? (item.template_road_id ? `Road #${item.template_road_id}` : 'Own GPX')
            : `Road #${item.id}`;

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input
                    type="checkbox"
                    checked={hasOwnGpx}
                    readOnly
                    className="readonly-checkbox"
                />
                <span>{sourceText}</span>
            </div>
        );
    };

    if (items.length === 0) {
        return (
            <div className="empty-state">
                <span className="material-icons-outlined">inbox</span>
                <p>Brak danych</p>
            </div>
        );
    }

    return (
        <div className="table-wrap">
            <table className="admin-table stage-import-table">
                <thead>
                    <tr>
                        <th style={{ width: '65px' }}>ID</th>
                        <th>Name</th>
                        <th style={{ width: '80px' }}>Type</th>
                        <th style={{ width: '110px' }}>Section</th>
                        <th style={{ width: '140px' }}>ResultID</th>
                        <th style={{ width: '140px' }}>Typ</th>
                        <th style={{ width: '70px' }}>Run</th>
                        <th style={{ width: '110px' }}>Kind</th>
                        <th style={{ width: '150px' }}>GPX Source</th>
                        <th style={{ width: '120px' }}>Length [m]</th>
                        <th style={{ width: '120px' }}>Distance [km]</th>
                        <th style={{ width: '140px' }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(item => (
                        <tr key={`${item.type}-${item.id}`}>
                            <td className="mono">{item.id}</td>
                            <td>{item.name || ''}</td>
                            <td>{getTypeBadge(item.type)}</td>
                            <td>{item.section || ''}</td>
                            <td className="mono">
                                {item.result_stage_id !== null && item.result_stage_id !== undefined
                                    ? item.result_stage_id
                                    : ''}
                            </td>
                            <td>{item.stage_typ || ''}</td>
                            <td className="mono">
                                {item.run_no !== null && item.run_no !== undefined
                                    ? item.run_no
                                    : ''}
                            </td>
                            <td>
                                {item.type === 'stage' && getKindBadge(item.kind || 'OS')}
                            </td>
                            <td className="mono">{getGpxSource(item)}</td>
                            <td className="mono">
                                {item.length_m ? formatNumber(item.length_m, 2) : ''}
                            </td>
                            <td className="mono">
                                {item.distance_km ? formatNumber(item.distance_km, 3) : ''}
                            </td>
                            <td>
                                <div className="actions-cell">
                                    <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => onEdit(item)}
                                        disabled={loading}
                                        title="Edit"
                                        style={{ marginRight: '8px' }}
                                    >
                                        <span className="material-icons-outlined">edit</span>
                                    </button>
                                    <button
                                        className="btn btn-danger btn-sm"
                                        onClick={() => handleDelete(item)}
                                        disabled={loading}
                                        title="Delete"
                                    >
                                        <span className="material-icons-outlined">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default StageImportTable;
